exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget {\n  border-radius: 5px;\n  -webkit-box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2); }\n  .widget .m-portlet__head-icon i {\n    font-size: 4em !important; }\n  .widget .m-portlet__head {\n    border-bottom: none !important;\n    padding: 0 !important; }\n  .widget .m-portlet__head .m-portlet__head-caption {\n      width: 100%; }\n  .widget .m-portlet__head .m-portlet__head-caption .m-portlet__head-title {\n        padding: 7px !important;\n        width: 100%; }\n  .widget .m-portlet__head .m-portlet__head-caption .m-portlet__head-title .m-portlet__head-icon {\n          width: 20%; }\n  .widget .m-portlet__head .m-portlet__head-caption .m-portlet__head-title .texts {\n          width: 100%;\n          text-align: right; }\n  .widget .m-portlet__head .m-portlet__head-caption .m-portlet__head-title .texts .m-portlet__head-text {\n            display: block; }\n  .widget .m-portlet__head .m-portlet__head-caption .m-portlet__head-title .texts .body {\n            font-size: 2em; }\n  .widget .m-portlet__body {\n    padding: 0 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/widget/widget.component.scss
// module id = ../../../../../src/app/shared/widget/widget.component.scss
// module chunks = main